module.exports = __webpack_public_path__ + "img/sort01.07c71b43.jpg";